import { withFeatureBranch } from '../../../redux/flags';
import FavouriteButton from './FavouriteButton';
import FavouriteButtonContainer from './FavouriteButton.container';
import FavouriteButtonWithPopover from './FavouriteButtonWithPopover';
export default FavouriteButtonContainer(withFeatureBranch({ add_to_faves_2: FavouriteButtonWithPopover })(FavouriteButton));
//# sourceMappingURL=index.js.map